import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'shards-react';
import { useRequestHook } from '../../utils/hooks/hooks';
import { addLoadingFlag, removePageFlags, reorderThumbnails } from '../../utils/redux/actions';
import Loading from '../Loading';

const ViewerOverlay = ({ dispatch, page, isDeleted, updateDocumentsList, documentId, thumbnails, isLoading }) => {
	const classes = `tilted-message text-white m-0 bg-${isDeleted ? 'danger' : 'secondary'}`;
	const title = page.toString().includes('diva') ?
		`DiVA Seite ${Number(page.split('-')[page.split('-').length - 1])} wird angezeigt` : `Seite ${page + 1} ${isDeleted ? 'wurde gelöscht' : 'wird angezeigt'}`;

	const { handleRequest } = useRequestHook();

	const elementPosition = {
		top: 'min(50vh, 50%)',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	};

	const restorePage = () => {
		dispatch(addLoadingFlag(page));

		handleRequest('post', '/thumbnails/restore-thumbnail', { documentId, page }, (response) => {
			dispatch(removePageFlags(page)); // remove isDelete and isLoading flags from the page

			const newThubnailsList = {
				...thumbnails,
				columns: {
					...thumbnails.columns,
					not_detected: {
						...thumbnails.columns.not_detected,
						pageIds: [...thumbnails.columns.not_detected.pageIds, `page-${page}`],
					},
				},
				pages: {
					...thumbnails.pages,
					[`page-${page}`]: response.pageData,
				},
			}; // add restored page info to other thumbnsails

			dispatch(reorderThumbnails(newThubnailsList)); // update thumbnails

			// update docInfo
			const updateInfoElems = (element) => {
				const result = { ...element };

				if (element.name === 'Zuletzt geändert: ') result.value = response.updatedAt;

				if (element.name === 'Status: ') result.value = response.status;

				return result;
			};

			updateDocumentsList((oldDocList) => oldDocList.map((docInfo) => (docInfo.documentId === documentId ? { ...docInfo, infoBox: docInfo.infoBox.map(updateInfoElems) } : docInfo)));
		});
	};

	return (
		<div className='wrapper-tilted-message'>
			<h4 className={classes} style={{width: page.toString().includes('diva') && '25rem'}}>{title}</h4>
			{isDeleted && (
				<Button className='position-absolute' style={elementPosition} theme='success' size='lg' disabled={isLoading} onClick={restorePage}>
					{isLoading ? <Loading /> : 'Gelöschte Seite wiederherstellen'}
				</Button>
			)}
		</div>
	);
};

/**
 * Take the id of saved in redux document and return it
 * in components props.
 */
const mapStateToProps = ({ savedDocument }, { page }) => {
	const { id, pages, thumbnails } = savedDocument;
	const isLoading = pages?.[page]?.isLoading;

	return { documentId: id, thumbnails, isLoading };
};

export default connect(mapStateToProps)(ViewerOverlay);
